"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUrl = void 0;
const signals_1 = require("@wix/services-manager/core-services/signals");
const utils_1 = require("./utils");
const createUrl = ({ externalBaseUrl, requestUrl }, getService) => {
    const window = globalThis.window;
    const signalsService = getService(signals_1.SignalsServiceDefinition);
    const computedExternalBaseUrl = signalsService.signal(externalBaseUrl || window?.location?.origin || '');
    const currentUrlWithQueryParams = signalsService.signal(requestUrl || window?.location.href || '');
    const currentUrl = signalsService.computed(() => {
        if (computedExternalBaseUrl.get()) {
            const relativeUrl = (0, utils_1.getRelativeUrl)(currentUrlWithQueryParams.get(), computedExternalBaseUrl.get());
            const isHomePageUrl = relativeUrl === './';
            const replaceStr = isHomePageUrl ? computedExternalBaseUrl.get() : `${computedExternalBaseUrl.get()}/`;
            return relativeUrl.replace('./', replaceStr);
        }
        return '';
    });
    return {
        externalBaseUrl: computedExternalBaseUrl.get(),
        currentUrl: currentUrl.get(),
        currentUrlWithQueryParams: currentUrlWithQueryParams.get(),
    };
};
exports.createUrl = createUrl;
//# sourceMappingURL=url.js.map